import { createFileRoute } from "@tanstack/react-router";
import { PageShell } from "@/components/page-shell";
import { Webhook } from "lucide-react";

export const Route = createFileRoute("/webhook/")({
  component: WebhookPage,
});

function WebhookPage() {
  return (
    <PageShell title="Webhooks" backTo="/" maxWidth="2xl">
      <div className="rounded-xl border bg-card p-8 text-center">
        <Webhook className="w-12 h-12 text-muted-foreground/40 mx-auto mb-4" />
        <h2 className="text-lg font-medium mb-2">Webhook Events</h2>
        <p className="text-sm text-muted-foreground mb-6 max-w-md mx-auto">
          Receive real-time events from PostForMe when posts are created, updated, or published.
        </p>
        <div className="text-left space-y-2 max-w-md mx-auto">
          {[
            "social.post.created",
            "social.post.updated",
            "social.post.deleted",
            "social.post.result.created",
            "social.account.created",
            "social.account.updated",
          ].map((event) => (
            <div
              key={event}
              className="flex items-center gap-2 text-sm px-3 py-2 rounded-lg bg-muted"
            >
              <div className="w-2 h-2 rounded-full bg-emerald-500" />
              {event}
            </div>
          ))}
        </div>
      </div>
    </PageShell>
  );
}
